import { FormatEventPipe, FormatTimePipe } from './format-event.pipe';
import { DropZoneDirective } from './drop-zone.directive';

export const pipes: any[] = [FormatEventPipe, FormatTimePipe];
export const directives: any[] = [DropZoneDirective];

export * from './format-event.pipe';
export * from './drop-zone.directive';
